import { useToastStore } from '@/store/toast';
import { cn } from '@/lib/utils';
import { X, CheckCircle2, AlertCircle, Info, AlertTriangle } from 'lucide-react';

export function Toaster() {
  const { toasts, dismiss } = useToastStore();
  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2 max-w-sm w-full">
      {toasts.map(t => {
        const Icon = t.variant === 'success' ? CheckCircle2
          : t.variant === 'destructive' ? AlertCircle
          : t.variant === 'warning' ? AlertTriangle
          : Info;
        const tone = t.variant === 'success' ? 'border-success/50 bg-success/10 text-success'
          : t.variant === 'destructive' ? 'border-destructive/50 bg-destructive/10 text-destructive'
          : t.variant === 'warning' ? 'border-warning/50 bg-warning/10 text-warning'
          : 'border-info/50 bg-info/10 text-info';
        return (
          <div key={t.id} className={cn(
            'pointer-events-auto flex w-full items-start gap-3 rounded-md border p-4 shadow-lg backdrop-blur',
            'animate-in slide-in-from-right-full duration-300',
            tone
          )}>
            <Icon className="h-5 w-5 mt-0.5 shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="font-medium text-foreground">{t.title}</div>
              {t.description && <div className="text-sm text-muted-foreground mt-0.5">{t.description}</div>}
            </div>
            <button onClick={() => dismiss(t.id)} className="text-muted-foreground hover:text-foreground transition-colors">
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
